var SVG = require("svg.js");

SVG.getArcDefinition = (startAngle, angle, radius) => {
    var endAngle = startAngle + angle;    
    return {
        startX: radius * Math.cos(SVG.rad(startAngle)),
        startY: radius * Math.sin(SVG.rad(startAngle)),
        endX: radius * Math.cos(SVG.rad(endAngle)),
        endY: radius * Math.sin(SVG.rad(endAngle))
    };
};

SVG.getArcPathDescription = (startAngle, angle, radius) => {
    var arcDef = SVG.getArcDefinition(startAngle, angle, radius);
    return `M${arcDef.startX},${arcDef.startY} A${radius},${radius} 0 0,1 ${arcDef.endX},${arcDef.endY}`; //1 means clockwise
};

SVG.calcArcLength = (startAngle, angle, radius) => {
    var arcDef = SVG.getArcDefinition(startAngle, angle, radius);
    var arcLength = SVG.calcLineLength(arcDef.startX, arcDef.startY, arcDef.endX, arcDef.endY);
    
    return arcLength;
};

SVG.drawArcText = (paper, startAngle, angle, radius, tPathAttrs, text, textAttrs, lineHeight) => {
    var result = paper.set();

    while(text){
        var tParams = SVG.getArcPathDescription(startAngle, angle, radius);
       
        // path for text
        var arcLength = SVG.calcArcLength(startAngle, angle, radius);
        var textPart  = SVG.getTextPart(paper, text, arcLength, textAttrs);        

        var tText = paper.text((t) => t.tspan(textPart)).attr(textAttrs);
        tText.path(tParams);
        tText.textPath().attr(tPathAttrs);
        text = text.replace(textPart, "").trim();
        result.add(tText);
        radius = radius-(lineHeight || textAttrs["font-size"]);
    }

    return result;
};

SVG.getArrowPathDescription = (topX, topY, arrowAttrs) => {
    return `M${topX} ${topY + arrowAttrs.offset} L${(topX - arrowAttrs.width)} ${(topY - arrowAttrs.height)} L${topX + arrowAttrs.width},${topY - arrowAttrs.height} Z`;
};

SVG.drawArrowPath = (paper, topX, topY, arrowAttrs, rotationAngle) => {
    var arPathParams = SVG.getArrowPathDescription(topX, topY, arrowAttrs);
    var arPath = paper.path(arPathParams).rotate(rotationAngle, topX, topY);

    return arPath;
}

SVG.getLinePathDescription = (startX, startY, endX, endY) => {
    var lineDef = `M${startX},${startY} L${endX},${endY}`; 

    return lineDef;
};

SVG.calcLineLength = (startX, startY, endX, endY) => {
    var deltaX = startX - endX
    var deltaY = startY - endY
    var lineLength = Math.sqrt(Math.pow(deltaY, 2) + Math.pow(deltaX, 2));
    
    return lineLength;
};

SVG.drawLineText = (paper, startX, startY, endX, endY, tPathAttrs, text, textAttrs, lineHeight) => {
    var result = paper.set();
    while(text) {
        var tParams = SVG.getLinePathDescription(startX, startY, endX, endY);

        // path for text
        var tPath = paper.path(tParams);
        var lineLength = SVG.calcLineLength(startX, startY, endX, endY);
        var textPart  = SVG.getTextPart(paper, text, lineLength, textAttrs);            

        var tText = paper.text((t) => t.tspan(textPart)).attr(textAttrs);
        tText.path(tParams);
        tText.textPath().attr(tPathAttrs);
        text = text.replace(textPart, "").trim();
    
        result.add(tText);
        startY += lineHeight || textAttrs["font-size"];
        endY = startY;
    }
    
    return result;
};   

SVG.centerTextInCircle = (textLines, circleRadius) => {
    var textHeight = 0;
    textLines.each(function() {
        textHeight += this.bbox().height;
    });

    var circleHeight = 2* circleRadius;
    var heightOffset = (circleHeight - textHeight)/2

    textLines.each(function() {
        this.translate(0, heightOffset);
    });
};

SVG.calcTextLength = (paper, text, textAttrs) => {
    var temp = paper.text((t) => t.tspan(text));
    temp.attr(textAttrs);
    var width = temp.rbox().width;
    temp.remove();

    return width;
};

SVG.getTextPart = (paper, text, maxLength, textAttrs) => {
    var words = text.split(" ");
    if(words.length === 1){
        return text;
    };

    var lineLength = 0;
    var line = "";
    var result = "";
    var n = 0;

    while(n < words.length){
        result = line;
        line = line + words[n] + " ";
        lineLength = SVG.calcTextLength(paper, line, textAttrs);
        if(lineLength > maxLength){
            return result ?  result : words[0];
        }
        n++;
    };

    return text;
};

SVG.traverseSet = (element, callback) => {
    if(element.each){//set
        element.each(function(){
            SVG.traverseSet(this, callback);
        });
    } else {//element of set
        callback(element);
    }
};

SVG.rad = (degree) => {
    return degree * Math.PI / 180;
};